
import { SignInWithApple, SignInWithAppleOptions, SignInWithAppleResponse } from "@capacitor-community/apple-sign-in";
import { getRoute } from "./utils";

class AppleClient {

  async getToken(): Promise<SignInWithAppleResponse> {

    const options: SignInWithAppleOptions = {
      clientId: "com.effettandem.app",
      redirectURI: getRoute("/login"),
      scopes: "email name",
    };

    const result = await SignInWithApple.authorize(options);

    return result;
  }
}

const appleClient = new AppleClient;

export { appleClient };
